import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles'
import { compose } from 'redux';

import HomeIcon from '../icons/Home';
import style from './ControlPanel.scss';

class ControlPanel extends PureComponent {
  static propTypes = {
    onClickHome: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.initialState = {
      mouseover: false,
    };

    this.state = this.initialState;
  }
  handleMouseEnter = () => {
    this.setState({
      ...this.state,
      mouseover: true,
    });
  };

  handleMouseLeave = () => {
    this.setState({
      ...this.state,
      mouseover: false,
    });
  };

  render() {
    const { onClickHome } = this.props;
    const { mouseover } = this.state;

    return (
      <div className={style.controlPanel}>
        <div
          tabIndex="0"
          role="button"
          className={style.homeIconWrapper}
          onMouseEnter={this.handleMouseEnter}
          onMouseLeave={this.handleMouseLeave}
          onClick={onClickHome}
          onKeyDown={onClickHome}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="30" height="28" viewBox="0 0 30 28">
            <g fill="none" fillRule="evenodd" stroke="#fff" transform="translate(1 1)">
              <polyline points="0 10 0 0 10 0" />
              <polyline points="0 26 0 16 10 16" transform="matrix(1 0 0 -1 0 42)" />
              <polyline points="18 10 18 0 28 0" transform="matrix(-1 0 0 1 46 0)" />
              <polyline points="18 26 18 16 28 16" transform="rotate(180 23 21)" />
            </g>
          </svg>
          <div className={style.homeIcon}>
            <HomeIcon size={18} fill={mouseover ? '#4ee4b3' : '#fff'} />
          </div>
        </div>
      </div>
    );
  }
}

export default compose(
  //
  withStyles(style),
)(ControlPanel);
